/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BlockedCompany,
    BlockedCompanyFromJSON,
    BlockedCompanyFromJSONTyped,
    BlockedCompanyToJSON,
} from './BlockedCompany';

/**
 * 
 * @export
 * @interface GetBlockedCompaniesResponseAllOfData
 */
export interface GetBlockedCompaniesResponseAllOfData {
    /**
     * 
     * @type {Array<BlockedCompany>}
     * @memberof GetBlockedCompaniesResponseAllOfData
     */
    companies: Array<BlockedCompany>;
    /**
     * 次の企業を取得するためのオフセット
     * @type {string}
     * @memberof GetBlockedCompaniesResponseAllOfData
     */
    nextCursor?: string;
}

export function GetBlockedCompaniesResponseAllOfDataFromJSON(json: any): GetBlockedCompaniesResponseAllOfData {
    return GetBlockedCompaniesResponseAllOfDataFromJSONTyped(json, false);
}

export function GetBlockedCompaniesResponseAllOfDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBlockedCompaniesResponseAllOfData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companies': ((json['companies'] as Array<any>).map(BlockedCompanyFromJSON)),
        'nextCursor': !exists(json, 'next_cursor') ? undefined : json['next_cursor'],
    };
}

export function GetBlockedCompaniesResponseAllOfDataToJSON(value?: GetBlockedCompaniesResponseAllOfData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'companies': ((value.companies as Array<any>).map(BlockedCompanyToJSON)),
        'next_cursor': value.nextCursor,
    };
}

